export default (theme) => ({
  cellContent: {},
  dayNumber: {
    fontSize: 30,
    lineHeight: 1.5,
    color: theme.palette.textColor.secondary,
    padding: '0 5px',
  },
  padding: {
    padding: '0 5px',
  },
  flexBox: {
    display: 'flex',
    alignItems: 'center',
    padding: '0 0 10px',
    justifyContent: 'space-between',
  },
  flexBoxInline: {
    display: 'inline-flex',
    alignItems: 'center',
  },
  userPhotoWrapper: {
    borderRadius: '50%',
    width: 21,
    height: 21,
    marginRight: 10,
  },
  dayBorder: {
    border: `1px solid ${theme.palette.textColor.yellow}`,
  },
  nightBorder: {
    border: `1px solid ${theme.palette.textColor.darkBlue}`,
  },
  inactiveBorder: {
    border: `1px solid ${theme.palette.textColor.secondary}`,
  },
  userPhoto: {
    display: 'block',
    height: 19,
  },
  name: {
    fontSize: 14,
    fontWeight: 500,
    maxWidth: 55,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  day: {
    color: theme.palette.textColor.yellow,
  },
  night: {
    color: theme.palette.textColor.darkBlue,
  },
  inactive: {
    color: theme.palette.textColor.secondary,
  },
  startTime: {
    fontSize: 12,
    fontWeight: 400,
    color: theme.palette.textColor.blue,
    border: `1px solid ${theme.palette.borderColor.blue}`,
    borderRadius: '10px',
    marginLeft: 5,
    width: 56,
    padding: '1px 0 2px',
    textAlign: 'center',
  },
  equipmentBlock: {
    display: 'flex',
    alignItems: 'center',
    minWidth: 34,
    height: 21,
    maxWidth: 168,
    fontSize: 14,
    fontWeight: 500,
    fontFamily: 'Poppins',
  },
  equipmentNumber: {
    flexShrink: 0,
    color: '#fff',
    padding: '3px 6px',
    borderRadius: 20,
    textAlign: 'center',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  equipmentName: {
    marginLeft: 4,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  list: {
    maxHeight: 200,
    overflowY: 'auto',
    padding: '0 5px',
  },
  fullWidth: {
    maxWidth: 136,
  },
  width1: {
    maxWidth: 75,
  },
  greenBackground: {
    backgroundColor: theme.palette.background.lightGreen,
    minHeight: '100%',
  },
  holidayName: {
    color: theme.palette.textColor.green,
    fontSize: 14,
    fontWeight: 500,
    textTransform: 'capitalize',
    padding: '0 5px 8px',
    wordBreak: 'break-word',
  },
  emptyCellHolidayName: {
    textAlign: 'center',
    marginTop: 40,
  },
  dayOff: {
    color: theme.palette.textColor.white,
    backgroundColor: theme.palette.background.greenBright,
    border: `1px solid ${theme.palette.background.greenBright}`,
  },
  individualUsername: {
    paddingRight: 6,
    color: theme.palette.background.greenBright,
  },
  individualUserBorder: {
    border: `1px solid ${theme.palette.background.greenBright}`,
  }
});
